import LegalLayout from "@/components/LegalLayout";
import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/site";

const H = ({ children }) => (
  <h2 className="font-heading font-bold text-xl text-[#1A110B] pt-4">{children}</h2>
);

export default function SmsTerms() {
  return (
    <div data-testid="sms-terms-page">
      <LegalLayout title="SMS Terms &amp; Conditions" updated="June 2026">
        <p>
          These SMS Terms &amp; Conditions govern the text messaging program operated by{" "}
          {COMPANY.name} ("Beta-Tech Systems," "we," "us," or "our"). By opting in, you agree to
          these terms in addition to our{" "}
          <Link to="/terms" className="text-[#00B4C4] font-medium">Terms &amp; Conditions</Link> and{" "}
          <Link to="/privacy" className="text-[#00B4C4] font-medium">Privacy Policy</Link>.
        </p>

        <H>1. Program Description</H>
        <p>
          When you opt in, Beta-Tech Systems may send you SMS text messages related to appointment
          reminders, service and account updates, dispatch and technician notifications, and
          responses to your inquiries. This is a non-marketing, service-based messaging program.
        </p>

        <H>2. How to Opt In</H>
        <p>
          You may opt in by checking the SMS consent box on our{" "}
          <Link to="/contact" className="text-[#00B4C4] font-medium">contact form</Link> and providing
          your mobile number. Consent to receive text messages is not a condition of purchasing any
          goods or services.
        </p>

        <H>3. Message Frequency</H>
        <p>
          Message frequency varies based on your interactions with us and your active service
          requests.
        </p>

        <H>4. Cost</H>
        <p>
          <strong>Message and data rates may apply.</strong> Such charges are billed by and payable
          to your mobile service provider. Beta-Tech Systems does not charge for the messages
          themselves.
        </p>

        <H>5. Opt-Out</H>
        <p>
          You can cancel the SMS service at any time by texting <strong>STOP</strong> to the number
          from which you received messages. After you send <strong>STOP</strong>, we will send a
          confirmation message and then stop sending SMS messages. We also honor STOP, END, CANCEL,
          UNSUBSCRIBE, and QUIT. To rejoin, opt in again through our contact form.
        </p>

        <H>6. Help</H>
        <p>
          For help, reply <strong>HELP</strong> to any message or contact us at{" "}
          <a href={`tel:${COMPANY.phone}`} className="text-[#00B4C4] font-medium">{COMPANY.phone}</a>{" "}
          or through our{" "}
          <Link to="/contact" className="text-[#00B4C4] font-medium">contact form</Link>.
        </p>

        <H>7. Carriers &amp; Delivery</H>
        <p>
          Carriers (including but not limited to AT&amp;T, Verizon, T-Mobile, Sprint, U.S. Cellular,
          and others) are not liable for delayed or undelivered messages. Message delivery is subject
          to effective transmission from your wireless service provider and is not guaranteed.
        </p>

        <H>8. Privacy</H>
        <p>
          Your mobile information is handled in accordance with our{" "}
          <Link to="/privacy" className="text-[#00B4C4] font-medium">Privacy Policy</Link>.{" "}
          <strong>No mobile information will be shared with third parties or affiliates for marketing
          or promotional purposes.</strong> Text messaging originator opt-in data and consent will
          not be shared with any third parties.
        </p>

        <H>9. Changes</H>
        <p>
          We may update these SMS Terms from time to time. Updates will be posted on this page with a
          revised "Last updated" date.
        </p>
      </LegalLayout>
    </div>
  );
}
